import React from 'react';
import { AppBar, Toolbar, Box, IconButton, Avatar, Button, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { BrandLogo } from '../BrandLogo';
import { LogoutConfirmDialog } from '../LogoutConfirmDialog';
import { useFlowstateAuth, getInitials } from '../../context/AuthContext';
import { useThemeContext } from '../../context/ThemeContext';

export const Navbar = () => {
    const navigate = useNavigate();
    const { user, logout } = useFlowstateAuth();
    const { mode, toggleTheme } = useThemeContext();
    const isLight = mode === 'light';
    const [logoutDialogOpen, setLogoutDialogOpen] = React.useState(false);

    return (
        <AppBar 
            position="static" 
            elevation={0} 
            sx={{ 
                bgcolor: 'transparent', 
                borderBottom: isLight ? '1px solid #e2e8f0' : '1px solid #1f1f22' 
            }}
        >
            <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 3, md: 6 }, minHeight: '64px !important' }}>
                <Box
                    onClick={() => navigate('/interview-prep/')}
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                >
                    <BrandLogo size="large" isLight={isLight} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Tooltip title={isLight ? "Switch to Dark Mode" : "Switch to Light Mode"} arrow>
                        <IconButton onClick={toggleTheme} sx={{ color: isLight ? '#0f172a' : '#f1f5f9' }}>
                            {isLight ? <DarkModeIcon /> : <LightModeIcon />}
                        </IconButton>
                    </Tooltip>

                    {user ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Tooltip title={`Signed in as ${user.first_name || 'User'}`} arrow>
                                <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.85rem', fontWeight: 700 }}>
                                    {getInitials(user)}
                                </Avatar>
                            </Tooltip>
                            <Tooltip title="Logout" arrow>
                                <IconButton onClick={() => setLogoutDialogOpen(true)} size="small" sx={{ color: isLight ? '#64748b' : '#a1a1aa' }}>
                                    <LogoutIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    ) : (
                        <Button
                            variant="outlined"
                            onClick={() => navigate(`/interview-prep/login?redirect=${encodeURIComponent(window.location.pathname)}`)}
                            sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 700,
                                borderColor: isLight ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)',
                                color: isLight ? '#0f172a' : '#f1f5f9',
                                '&:hover': { borderColor: 'primary.main', bgcolor: 'transparent' }
                            }}
                        >
                            Log In
                        </Button>
                    )}
                </Box>
            </Toolbar>
            <LogoutConfirmDialog 
                open={logoutDialogOpen} 
                onClose={() => setLogoutDialogOpen(false)} 
                onConfirm={() => {
                    setLogoutDialogOpen(false);
                    logout();
                }} 
            />
        </AppBar>
    );
};
